import { render } from "./NotesTable.vue?vue&type=template&id=950ed7d6&ts=true"
import script from "./NotesTable.vue?vue&type=script&lang=ts"
export * from "./NotesTable.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__